<template>
  <div>
    <el-dialog :title="'添加银行卡'" :visible.sync="bankDddVisible" width="460px" :before-close="close" :close-on-press-escape="false" :close-on-click-modal="false">
      <div>
        <div class="types-top">
          <div class="texts">类型</div>
          <el-radio-group @change="changeRadio" v-model="radio">
            <el-radio :label="0">个人</el-radio>
            <el-radio :label="2">个体户</el-radio>
            <el-radio :label="1">企业</el-radio>
          </el-radio-group>
        </div>
        <div>
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item :label="radio == 0 ? '姓名':'公司名称'">
              <el-input v-model="form.userName" :placeholder="radio == 0 ? '请输入姓名':'请输入开户公司名称'"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
              <el-input v-model="form.bankCardNum"  @blur="recognitionBank" @input="inputCahnges" placeholder="请输入银行卡号"></el-input>
              <div class="tips">输入卡号自动识别开户行</div>
            </el-form-item>
            <el-form-item label="开户行">
              <el-select @change="changeSelect" v-model="form.bankName" placeholder="请选择开户行">
                <el-option v-for="item in bankList" :key="item.id" :label="item.bankName" :value="item.bankName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="银行联行号" v-if="radio == 1">
              <el-input v-model="form.receiverBankChannelNo" placeholder="请输入银行的联行号(问自己家财务)"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" v-if="radio == 2 || radio == 1">
              <el-input v-model="form.uscci" placeholder="纳税人识别号"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-button">
          <div class="card-button-cancel" @click="addCancel">取 消</div>
          <div class="card-button-confirm" @click="addBankCardFun">确 定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import debounce from '@/utils/debounce.js'
import { getPlatformUuid } from '@/utils/auth'
import mini from "@/api/mini";
const MiniModel = new mini()
export default {
  data() {
    return {
      shortName:'',
      // 个体户
      form:{
        userName:'', //账户名称
        bankCardNum:'', //银行卡卡号
        // shortName:'', // 银行卡开户行英文简称
        bankName:'', // 开户行中文
        // 企业
        receiverBankChannelNo:'', // 收款账户联行号(对公需要)
        // 企业 + 个体户
        uscci:'', //纳税人识别号
      },
      bankList:[],
      bankDddVisible: false,
      // 个人（默认）0，企业1，个体户:2
      radio: 0,
      types:'', // 1小程序，2公众号，3账户中心
    };
  },
  methods: {
    changeRadio(e) {
      console.log(e,'eeee')
      this.reset()
      // this.form.userName = ''
    },
    addBankCardFun() {
      debounce(()=> {
        this.addBankCard()
      },1000,true)
    },
    changeSelect(e) {
      console.log(e,'ere')
      for (let index in this.bankList) {
        if (this.bankList[index].bankName.indexOf(e) != -1) {
          this.shortName = this.bankList[index].shortName
          console.log(this.bankList[index].shortName,'AAA==')
          break
        }
      }
    },
    // 确定
    addBankCard() {
      console.log(this.types,this.form,'types父类型')
      // 处理找到对应的缩写英文
      // for (let index in this.bankList) {
      //   if (this.bankList[index].bankName.indexOf(this.form.bankName) != -1) {
      //     this.form.shortName = this.bankList[index].shortName
      //     break
      //   }
      // }
      if(!this.form.userName) {
        if(this.radio == 0) {
          this.$message.error('请输入姓名')
        }else{
          this.$message.error('请输入开户公司名称')
        }
        return
      }
      if(!this.form.bankCardNum) {
        this.$message.error('请输入银行卡卡号')
        return
      }
      if(!this.form.bankName) {
        this.$message.error('请选择开户行')
        return
      }
      if(!this.form.uscci) {
        if(this.radio != 0) {
          this.$message.error('请输入纳税人识别号')
          return
        }
      }
      if(!this.form.receiverBankChannelNo) {
        if(this.radio == 1) {
          this.$message.error('请输入银行联行号')
          return
        }
      }
      let params = {}
      if(this.radio == 0) {
        params = {
          bankType:this.radio,
          userName:this.form.userName,
          bankCardNum:this.form.bankCardNum,
          shortName:this.shortName,
          bankName:this.form.bankName
        }
      }else if(this.radio == 1){
        params = {
          bankType:this.radio,
          userName:this.form.userName,
          bankCardNum:this.form.bankCardNum,
          shortName:this.shortName,
          bankName:this.form.bankName,
          receiverBankChannelNo:this.form.receiverBankChannelNo,
          uscci:this.form.uscci,
        }
      }else if(this.radio == 2) {
        params = {
          bankType:this.radio,
          userName:this.form.userName,
          bankCardNum:this.form.bankCardNum,
          shortName:this.shortName,
          bankName:this.form.bankName,
          uscci:this.form.uscci,
        }
      }
      console.log(params,'paramsparams')
      // return
      // types：1小程序，2公众号，3账户中心
      this.$emit('bankAddHandel',params,this.types)
      console.log(this.radio,params,'类型',this.types)
    },
    addCancel() {
      this.close();
    },
    opens(bankList,type) {
      console.log(bankList,'bankList',type)
      this.bankList = bankList
      this.types = type
      this.radio = 0
      this.bankDddVisible = true;
    },
    reset() {
      Object.keys(this.form).map((key=> {
        this.form[key] = ''
      }))
    },
    close() {
      console.log("关闭==");
      this.bankDddVisible = false;
      this.reset()
    },
    inputCahnges(e) {
      console.log(e,'inputCahnges')
    },
    // 自动识别开户行
    recognitionBank() {
      let reg = /^\d+$/
      if(this.form.bankCardNum == '') {
        return
      }
      if(!reg.test(this.form.bankCardNum)) {
        this.$message.error('请输入正确银行卡号')
        console.log('没通过')
        return
      }
      console.log('自动识别开户行')
      let params = {
        bankCardNum: this.form.bankCardNum
      }
      MiniModel.openRecognitionBank(params).then(res => {
        if (res.data.code == 200) {
          console.log(res,'自动识别开户行')
          this.$message.success('识别成功')
          this.form.bankName = res.data.data.bank
          this.shortName= res.data.data.abbreviation
        } else {
          this.$message.error(res.data.message || res.data.info)

        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.types-top {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  // margin-left: 20px;
  .texts{
    text-align: right;
    padding-right: 12px;
    width: 100px;
  }
}

.card-button {
  display: flex;
  align-items: center;
  // justify-content: center;
  padding-top: 15px;
  flex-direction: row-reverse;
  // border-top: 1px solid #333;
  .card-button-confirm {
    width: 100px;
    height: 36px;
    background: #ff8622;
    border-radius: 2px;
    text-align: center;
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #ffffff;
    line-height: 36px;
    cursor: pointer;
    margin-left: 15px;
  }

  .card-button-cancel {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 36px;
    text-align: center;
    width: 100px;
    height: 36px;
    background: #eeeeee;
    border-radius: 2px;
    margin-left: 10px;
    cursor: pointer;
  }
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #ff8622 !important;
}

/deep/ .el-select .el-input__inner:focus {
  border-color: #ff8622 !important;
}
/* 选中后的字体颜色 */
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #ff8622 !important;
}
/* 选中后小圆点的颜色 */
/deep/ .el-radio__input.is-checked .el-radio__inner {
  background: #ff8622 !important;
  border-color: #ff8622 !important;
}
.item-input:hover {
  border: 1px solid #ff8622 !important;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-select{
  width: 100% !important;
}
.tips{
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #C1C1C1;
  line-height: 17px;
  // margin-left: 85px;
  // margin-top: -15px;

}
input::-webkit-input-placeholder {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #c1c1c1;
  line-height: 20px;
}

input:-moz-placeholder {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #c1c1c1;
  line-height: 20px;
}

input::-moz-placeholder {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #c1c1c1;
  line-height: 20px;
}

input::-ms-input-placeholder {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #c1c1c1;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/bankAdd.vue